<header class="topheader" id="scrollId">
  <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-white">
    <div class="container">

      <a class="navbar-brand" tabindex="-1" routerLink="" class="logo-dyr"><img src="assets/img/logo_dyre.svg"
          alt="" /></a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse top-menu" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item active" *ngIf="!this.app.currentUser">
            <ul class="login-regster">
              <!--data-toggle="modal" data-target="#exampleModal"-->
              <li class="wlogregitr"><a class="nav-link pr-1 wloggin" (click)="toggleModal()" style="cursor: pointer;"
                  #closeLoginModal data-backdrop="static" data-keyboard="false">Logg inn / Registrer</a></li>
              <!-- <li><a class="nav-link pl-0" href="https://www.dyreid.no/savnet-og-funnet" target="_blank"></a></li> -->
            </ul>
          </li>
          <li class="nav-item active" *ngIf="this.app.currentUser">
            <ul class="login-regster">
              <li>
                <div ngbDropdown class="loggedin-user">
                  <div class="userdropdwn" id="dropdownBasic1" ngbDropdownToggle>
                    <div class="user-name" *ngIf="this.app.currentUser.FirstName">
                      {{ this.app.currentUser.FirstName + " " + this.app.currentUser.LastName }}
                    </div>
                    <div class="profil-photo">
                      <img src="assets/img/user_icn.svg" alt="" title="" class="img-fluid profil-img">
                    </div>
                  </div>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem *ngIf="showProfile" id="profileDropDown"><img src="assets/img/profile.svg"
                        alt="" title=""> <a href="userprofile">Profile</a></button>
                    <button ngbDropdownItem (click)="this.app.signOut()"><img src="assets/img/logout.svg" alt=""
                        title="">
                      {{ "Logout" | translate }} </button>
                  </div>
                </div>
              </li>
            </ul>
          </li>
          <li class="nav-item" tabindex="-1" routerLink="search">
            <a class="nav-link" href="javascript:void(0)">Søk</a>
          </li>
          <!-- <li class="nav-item" (click)="_toggleSidebar()">
            <a class="nav-link" href="javascript:void(0)">Meny</a>
          </li> -->
          <li class="togglesdebtn">
            <button type="button" tabindex="-1" data-toggle="collapse" (click)="toggleSidebar()"
              aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>



<!-- Modal -->
<div class="my-modal loginModal" tabindex="-1" *ngIf="isLogin">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Logg inn</h5>
        <button type="button" class="close" (click)="toggleModal()" aria-label="Close">
          <span aria-hidden="true">Lukk</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="login-pg">
          <div class="login-bttns-sec">
            <!-- <p style="text-align: justify;">
              Vi har dessverre midlertidig problemer med innlogging på vår Savnet & Funnet tjeneste, grunnet vedlikehold.<br>

Men du kan bruke tjenesten ved å laste ned vår DyreID app og logge deg inn med dine innloggingsdetaljer for Min side i DyreID. Appen finnes tilgjengelig i App store og Google Play
            </p> -->
             <button type="btn" class="btn btn-white width-100 mb-3" (click)="LoginWithMinside()"> <img
                src="assets/img/logo_dyre.svg" alt="" class="img-fluid"><i class="fas fa-arrow-right"></i></button>
             <!--<button type="btn" class="btn btn-white width-100 mb-3" (click)="socialSignIn('facebook')"> <span><img
                  src="assets/img/facebook-login.svg" alt="" class="img-fluid socl-icon"><span
                  class="social-font">Facebook</span></span><i class="fas fa-arrow-right"></i></button>-->
            <button type="btn" class="btn btn-white width-100 mb-2" (click)="socialSignIn('google')"> <span><img
                  src="assets/img/google-icon.svg" alt="" class="img-fluid socl-icon"><span
                  class="social-font">Google</span></span><i class="fas fa-arrow-right"></i></button>
            <button type="btn" class="btn btn-white width-100 mb-3" (click)="LoginWithOTP()"><span
              class="">{{'Login / register with OTP'| translate}}</span> <i class="fas fa-arrow-right"></i></button>      
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="my-modal loginModal" tabindex="-1" *ngIf="sidebar">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" (click)="toggleSidebar()" aria-label="Close">
          <span aria-hidden="true">Lukk</span>
        </button>
      </div>
      <div>
        <div class="row">
          <div class="col-sm-6">
            <div class="sidemenu-content">
              <h1>Meld et dyr</h1>
              <div class="callto-action">
                <a href='{{foundPath}}' class="btn btn-white mb-2 f-16" type="btn">
                  {{'Lost' | translate}} <i class="fas fa-arrow-right"></i>
                </a>
              </div>
              <div class="callto-action">
                <a href='{{lostPath}}' class="btn btn-white mb-2 f-16" type="btn">
                  {{'Found' | translate}}
                  <i class="fas fa-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="sidemenu-content">
              <h1 style="margin-top: 48px;"></h1>
              <div class="callto-action">
                <a href="{{homepath}}" class="btn btn-white mb-2 f-16" type="btn">
                  {{'Home' | translate}}<i class="fas fa-arrow-right"></i>
                </a>
              </div>
              <div class="callto-action">
                <a href="dashboard" class="btn btn-white mb-2 f-16" type="btn">
                  {{'My Reported Pets' | translate}}<i class="fas fa-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
          <!-- <div class="col-sm-4">
            <div class="sidemenu-content">              
            </div>
          </div> -->
        </div>
        <!-- <div style="margin-left: 100px;">
          <div class="leftbanner-content" style="background-color:#B1CF91 !important">
            <div class="callto-action">
              <a href="dashboard" class="btn btn-white width-50 mb-2 f-16" type="btn">
                My Reported Pets<i class="fas fa-arrow-right"></i>
              </a>
            </div>
            <div class="callto-action">
              <a href="/" class="btn btn-white width-50 mb-2 f-16" type="btn">
                Home<i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>-->
        </div> 
      </div>
    </div>
  </div>